interface FieldInfo {
  code: string | number;
  message: string;
}

export interface ParsedApiError {
  fields: Record<string, FieldInfo>;
  details?: {
    message: string;
    code: string | number;
  };
}

/**
 * Parse a 400 Bad Request response body into a structured error object.
 *
 * Handles two response formats from the backend:
 * 1. Global errors: { non_field_errors: [{ message, code }] }
 * 2. Field-level errors: { field_name: [{ message, code }] }
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseClientError(data: any): ParsedApiError {
  if (data && data.non_field_errors) {
    return {
      details: data.non_field_errors[0],
      fields: {},
    };
  }

  const fields: Record<string, FieldInfo> = {};
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (Array.isArray(value) && value.length > 0) {
        fields[key] = value[0] as FieldInfo;
      }
    });
  }
  return {fields};
}
